// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import moment from "moment";

// function ProductFeatureContent(props) {
//   const { featureDetail } = props;

//   useEffect(() => {}, []);

//   //  dynamically manage different status
//   const manageSalesStatus = (status) => {
//     let defaultClass = "status_color1 text-white";

//     switch (status) {
//       case "Draft":
//         defaultClass = "text-light status_color2";
//         break;
//       case "Active":
//         defaultClass = "text-light status_color3";
//         break;
//       case "Pending for Approval":
//         defaultClass = "text-dark status_color4";
//         break;
//       case "Fulfilled":
//         defaultClass = "text-light status_color5";
//         break;
//       case "Rejected":
//         defaultClass = "text-light status_color6";
//         break;
//       case "Confirmed":
//         defaultClass = "text-light status_color1";
//         break;
//       case "Partially Billed":
//         defaultClass = "text-light status_color8";
//         break;

//       default:
//         break;
//     }

//     return (
//       <span
//         className={`py-2 pl-4 pr-4 pt-2 pb-2 h5 text-sm rounded-full ${defaultClass} `}
//       >
//         {status}
//       </span>
//     );
//   };

//   // view subscription by going to subscription module

//   return (
//     <section className="mt-2 w-full">
//       <Grid className=" pb-5  " container spacing={2}>
//         <Grid className="border-2 mx-4  bg-light  my-2 " item xs={12}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <span className="#476ef8 font-bold ">
//                 <li class="list-group-item active font-bold text-center">
//                   {" "}
//                   <h2>{featureDetail?.Feature_Name} hello</h2>{" "}
//                 </li>
//               </span>
//             </Grid>
//             <Grid item xs={12}>
//               <div className="row">
//                 <div className="col">
//                   <ul class="list-group">
//                     <li class="list-group-item">
//                       {" "}
//                       Product :{" "}
//                       <span className="text-primary font-bold">
//                         {" "}
//                         {featureDetail?.Product_Name}{" "}
//                       </span>{" "}
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Description :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {featureDetail?.Product_Description}{" "}
//                       </span>{" "}
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Ref No :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {featureDetail?.Product_Id}{" "}
//                       </span>{" "}
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Action Url Web :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {featureDetail?.Action_URL_Web}{" "}
//                       </span>{" "}
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Action Url Mobile :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {featureDetail?.Action_URL_Web}{" "}
//                       </span>{" "}
//                     </li>
//                   </ul>
//                 </div>
//                 <div className="col">
//                   <ul class="list-group">
//                     <li class="list-group-item font-bold  text-center">
//                       {" "}
//                       {manageSalesStatus(featureDetail?.Status_Name)}{" "}
//                     </li>

//                     <li className="list-group-item">
//                       Background Color:
//                       <span
//                         className="p-1 m-1"
//                         style={{
//                           backgroundColor: featureDetail?.Background_Color,
//                         }}
//                       >
//                         ____________
//                       </span>
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Display Order :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {featureDetail?.Display_Order}{" "}
//                       </span>{" "}
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Created Date :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {moment(featureDetail?.Encoded_Date).format("LLL")}{" "}
//                       </span>{" "}
//                     </li>
//                     <li class="list-group-item">
//                       {" "}
//                       Created By :{" "}
//                       <span className="text-primary">
//                         {" "}
//                         {featureDetail?.Encoded_By_Name}{" "}
//                       </span>{" "}
//                     </li>

//                     {/* <li class="list-group-item"> Mobile Active : <span className="text-primary" > {featureDetail?.App_Visible_Id === 1 ? <span className="text-success font-bold" >YES</span> : <span className="text-danger font-bold" >NO</span> }  </span> </li>
//                                 <li class="list-group-item"> Web Active : <span className="text-primary" > {featureDetail?.Web_Visible_Id === 1 ?  <span className="text-success font-bold" >YES</span> : <span className="text-danger font-bold" >NO</span>}  </span> </li>
//                          */}
//                   </ul>
//                 </div>
//               </div>

//               <div className="text-center card mt-1">
//                 <div className="text-lead text-center font-bold">Preview </div>

//                 <div class="grid grid-cols-1 gap-4">
//                   <div className="ml-5 mb-2">
//                     <a
//                       target="blank"
//                       href={featureDetail?.Image_URL}
//                       className="ml-4"
//                     >
//                       <img
//                         src={featureDetail?.Image_URL}
//                         alt="product"
//                         width="500"
//                         srcset=""
//                       />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Grid>
//     </section>
//   );
// }

// export default ProductFeatureContent;

import React, { useEffect } from "react";
import moment from "moment";

function ProductFeatureContent(props) {
  const { featureDetail } = props;

  const manageSalesStatus = (status) => {
    const statusClassMap = {
      Draft: "bg-yellow-400 text-black",
      Active: "bg-green-600 text-white",
      "Pending for Approval": "bg-yellow-200 text-black",
      Fulfilled: "bg-blue-500 text-white",
      Rejected: "bg-red-500 text-white",
      Confirmed: "bg-indigo-600 text-white",
      "Partially Billed": "bg-purple-500 text-white",
    };

    return (
      <span
        className={`px-4 py-2 rounded-full text-sm font-semibold ${
          statusClassMap[status] || "bg-gray-300 text-black"
        }`}
      >
        {status}
      </span>
    );
  };

  return (
    <section className="w-full max-w-4xl mx-auto p-4">
    <div className="border border-gray-200 bg-white rounded-2xl shadow-lg px-8 py-6 transition-all hover:shadow-xl">
      {/* Status Badge */}
      <div className="flex items-center justify-end mb-4">
        <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm font-semibold">
          {manageSalesStatus(featureDetail?.Status_Name)}
        </div>
      </div>
  
      {/* Feature Title */}
      <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
        {featureDetail?.Feature_Name}
      </h2>
  
      {/* Details Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Left Column */}
        <div className="space-y-3">
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Product:</span>
            <span className="text-sm text-gray-900 font-semibold">{featureDetail?.Product_Name}</span>
          </div>
          <div className="flex items-start">
            <span className="text-sm font-medium text-gray-500 w-32">Description:</span>
            <span className="text-sm text-gray-900 font-semibold">{featureDetail?.Product_Description}</span>
          </div>
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Ref No:</span>
            <span className="text-sm text-gray-900 font-semibold">{featureDetail?.Product_Id}</span>
          </div>
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Action URL Web:</span>
            <span className="text-sm text-blue-600 font-semibold hover:underline">{featureDetail?.Action_URL_Web}</span>
          </div>
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Action URL Mobile:</span>
            <span className="text-sm text-blue-600 font-semibold hover:underline">{featureDetail?.Action_URL_Mobile}</span>
          </div>
        </div>
  
        {/* Right Column */}
        <div className="space-y-3">
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Background Color:</span>
            <span
              className="w-6 h-6 rounded-full border border-gray-300"
              style={{ backgroundColor: featureDetail?.Background_Color }}
            ></span>
            <span className="text-sm text-gray-900 font-semibold ml-2">{featureDetail?.Background_Color}</span>
          </div>
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Display Order:</span>
            <span className="text-sm text-gray-900 font-semibold">{featureDetail?.Display_Order}</span>
          </div>
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Created Date:</span>
            <span className="text-sm text-gray-900 font-semibold">
              {moment(featureDetail?.Encoded_Date).format("LLL")}
            </span>
          </div>
          <div className="flex items-center">
            <span className="text-sm font-medium text-gray-500 w-32">Created By:</span>
            <span className="text-sm text-gray-900 font-semibold">{featureDetail?.Encoded_By_Name}</span>
          </div>
        </div>
      </div>
  
      {/* Image Preview */}
      {featureDetail?.Image_URL && (
        <div className="mt-8 flex flex-col items-center justify-center">
          <div className="text-lg font-semibold text-gray-800 mb-3">Preview</div>
          <a
            href={featureDetail?.Image_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <img
              src={featureDetail?.Image_URL}
              alt="Product Preview"
              className="max-w-md w-full h-auto object-contain"
            />
          </a>
        </div>
      )}
    </div>
  </section>
  );
}

export default ProductFeatureContent;
